import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'summary', label: 'Summary', type: 'textarea', rows: 2 },
    { key: 'description', label: 'Full description', type: 'rich-text' },
    {
        key: 'status',
        label: 'Status',
        type: 'select',
        options: [
            { value: 'ongoing', label: 'Ongoing' },
            { value: 'completed', label: 'Completed' },
        ],
    },
    { key: 'category', label: 'Category', type: 'text', placeholder: 'e.g. Health, Education, Employment' },
    { key: 'location', label: 'Location', type: 'text' },
    { key: 'start_date', label: 'Start date', type: 'text', placeholder: 'YYYY-MM-DD' },
    { key: 'end_date', label: 'End date', type: 'text', placeholder: 'YYYY-MM-DD or empty' },
    { key: 'beneficiaries', label: 'Beneficiaries', type: 'text' },
    { key: 'outcomes', label: 'Outcomes', type: 'array', hint: 'Comma-separated list' },
    { key: 'image_url', label: 'Cover image', type: 'upload-image', prefix: 'projects' },
    { key: 'gallery', label: 'Gallery images', type: 'images-list', prefix: 'projects/gallery' },
    { key: 'featured', label: 'Featured', type: 'checkbox', checkboxLabel: 'Feature this on homepage' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'title', label: 'Title', primary: true },
    { key: 'status', label: 'Status', render: (r) => r.status },
    { key: 'category', label: 'Category' },
    { key: 'location', label: 'Location' },
];

const defaultItem = {
    title: '',
    summary: '',
    description: '',
    status: 'ongoing',
    category: 'General',
    location: '',
    start_date: '',
    end_date: '',
    beneficiaries: '',
    outcomes: [],
    image_url: '',
    gallery: [],
    featured: false,
    order: 99,
};

export default function AdminProjectsPage() {
    return (
        <CrudManager
            resource="projects"
            title="Projects"
            description="CSR projects and community initiatives."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title', 'category', 'location']}
        />
    );
}
